import { useEffect, useState } from "react";

export function useAuth() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch("/api/me", {
          credentials: "include",
        });
        if (response.status === 401) {
          console.log("User not authenticated, redirecting to login");
          window.location.href = "/api/login";
          return;
        }

        if (!response.ok) {
          throw new Error(`/api/me failed: ${response.status}`);
        }

        setUser(await response.json());
      } catch (err) {
        console.error("Auth check failed", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { loading, user };
}
